import React, { Fragment, useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useSignIn, useSignOut } from "react-auth-kit";
import {
  createClientIdQueryString,
  sendApiRequest,
} from "../../services/Base/base-service";
import {
  flowTypes,
  notifyUser,
  setFormatHandler,
  showFlowType,
} from "../../services/helpers";

import UserContext from "../../store/user-context";
import {
  Icon,
  Modal,
  ModalBody,
  ModalHeader,
  FormGroup,
  Form,
  Input,
  Toggle,
  Button,
  Alert,
  Spinner,
  Select,
} from "design-react-kit";

const ExternalFlowConfigurationModal = ({
  modalOpen,
  modalCloseHandler,
  selectedClient,
}) => {
  const [isActive, setIsActive] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [externalFlowConfig, setExternalFlowConfig] = useState(null);
  const [format, setFormat] = useState(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const signIn = useSignIn();
  const signOut = useSignOut();

  const userContext = useContext(UserContext);

  const enableExternalFlowHandler = (e) => {
    setIsActive(e.target.checked);
    setExternalFlowConfig((curState) => {
      return {
        ...curState,
        isActive: e.target.checked,
      };
    });
  };

  useEffect(() => {
    if (modalOpen) {
      setIsLoading(true);
      setError(null);
      setExternalFlowConfig(null);
      sendApiRequest(
        "ExternalFlowConfiguration/GetSingleExternalFlowConfiguration",
        "GET",
        true,
        { clientId: selectedClient.clientId },
        signIn,
        signOut,
        navigate,
        createClientIdQueryString,
        userContext
      ).then((response) => {
        if (response !== undefined) {
          if (response.errors !== null) {
            setError(response.errors);
          } else {
            setExternalFlowConfig(response.data);
            setFormatHandler(response.data.flowType, setFormat);
            setIsActive(response.data.isActive);
          }
          setIsLoading(false);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalOpen]);

  useEffect(() => {
    if (modalOpen) {
      setTimeout(() => {
        if (externalFlowConfig !== null) {
          document.querySelector("input.isActive").checked = isActive;
        }
      }, 500);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalOpen, isActive]);

  const upsertExternalFlowConfiguration = (e) => {
    e.stopPropagation();
    setError(null);
    let hasError = false;

    let data;
    data = externalFlowConfig;

    if (
      externalFlowConfig.clientId === null ||
      externalFlowConfig.clientId === 0
    ) {
      data = { ...data, clientId: selectedClient.clientId };
    }

    if (
      data.documentsAvailabilityDays === null ||
      data.documentsAvailabilityDays === undefined ||
      data.documentsAvailabilityDays === ""
    ) {
      hasError = true;
      setError((prevState) =>
        prevState !== null
          ? [
              ...prevState,
              `Il valore dei "Giorni di permanenza PDF già trasmessi a EN CORE" è obbligatorio`,
            ]
          : [
              `Il valore dei "Giorni di permanenza PDF già trasmessi a EN CORE" è obbligatorio`,
            ]
      );
    }

    if (!hasError) {
      setIsLoading(true);
      sendApiRequest(
        `ExternalFlowConfiguration/UpsertExternalFlowConfiguration`,
        "POST",
        true,
        data,
        signIn,
        signOut,
        navigate,
        null,
        userContext
      ).then((response) => {
        if (response !== undefined) {
          if (response.errors !== null) {
            setError(response.errors);
            setIsLoading(false);
          } else {
            modalCloseHandler();
            notifyUser(
              "Aggiornamento configurazione per tipologia servizio completato con successo!",
              "success",
              "it-check"
            );
          }
        }
      });
    }
  };

  const handleFormatChange = (selectedOption) => {
    setFormat(selectedOption);
    setExternalFlowConfig((curState) => {
      return {
        ...curState,
        flowType: selectedOption.value,
      };
    });
  };

  return (
    <Modal
      isOpen={modalOpen}
      toggle={modalCloseHandler}
      align="center"
      scrollable
      labelledBy="externalFlowConfig"
    >
      <ModalHeader toggle={modalCloseHandler} id="externalFlowConfig">
        <h6 className="text-capitalize text-center">
          Gestione flussi esterni (configurazione)
        </h6>
      </ModalHeader>
      <ModalBody>
        <div className="mb-4">
          <h5 className="text-capitalize">
            Tipologia Servizio:{" "}
            <span style={{ color: "#0073e6 " }}>
              {selectedClient?.clientCode}
            </span>
          </h5>
          <h6 className="text-capitalize" style={{ color: "#0073e6 " }}>
            {selectedClient?.clientCodeName}
          </h6>
        </div>
        {isLoading && <Spinner double active />}
        {!isLoading && error !== null && error.length !== undefined && (
          <Alert color="danger">
            {error.map((item) => (
              <p key={item}>{item}</p>
            ))}
          </Alert>
        )}
        {externalFlowConfig !== null && externalFlowConfig !== undefined && (
          <Form className="mr-auto ml-auto mt-5">
            <Fragment>
              {externalFlowConfig.flowType !== null &&
                externalFlowConfig.flowType !== undefined && (
                  <div className="p-input-wrapper">
                    <div className="p-label" htmlFor="secretKey">
                      Fromato
                    </div>
                    <p id="secretKey" className="p-input">
                      {showFlowType(externalFlowConfig.flowType)}
                    </p>
                  </div>
                )}
              {(externalFlowConfig.flowType === null ||
                externalFlowConfig.flowType === undefined) && (
                <div className="bootstrap-select-wrapper mb-5">
                  <label htmlFor="format">Formato</label>
                  <Select
                    id="format"
                    placeholder="Inserisci formato"
                    aria-label="Inserisci formato"
                    value={format}
                    onChange={handleFormatChange}
                    options={flowTypes}
                  />
                </div>
              )}
              <div className="form-row">
                <FormGroup className="col-sm-12 m-0 position-relative">
                  <Input
                    id="documentAvailabilityDays"
                    type="number"
                    min={0}
                    label="Giorni di permanenza PDF già trasmessi a EN CORE"
                    placeholder="Inserisci Giorni di permanenza PDF già trasmessi a EN CORE"
                    value={externalFlowConfig.documentsAvailabilityDays}
                    onChange={(e) =>
                      setExternalFlowConfig((curState) => {
                        return {
                          ...curState,
                          documentsAvailabilityDays: e.target.value,
                        };
                      })
                    }
                  />
                </FormGroup>
                <FormGroup
                  check
                  className="form-check-group d-flex align-items-center justify-content-start mb-3 isActive"
                >
                  <Toggle
                    id="isActive-toggle"
                    className="isActive"
                    onClick={(e) => enableExternalFlowHandler(e)}
                  />
                  <span className="mb-2 toggles-span" id="isActive">
                    Accetta flussi esterni
                  </span>
                </FormGroup>
              </div>
            </Fragment>

            <FormGroup className="col-sm-12 mb-2 d-flex align-items-center justify-content-end">
              <Button
                id="user-cancel"
                color="white"
                className="mr-2"
                onClick={modalCloseHandler}
              >
                Annulla
              </Button>
              <Button
                style={{
                  backgroundColor: "#5EB423",
                  color: "#fff",
                  padding: "7px 15px",
                }}
                id="user-save"
                onClick={(e) => upsertExternalFlowConfiguration(e)}
              >
                <Icon
                  icon="it-check"
                  fill="#ffffff"
                  onClick={(e) => upsertExternalFlowConfiguration(e)}
                />
                Salva
              </Button>
            </FormGroup>
          </Form>
        )}
      </ModalBody>
    </Modal>
  );
};

export default ExternalFlowConfigurationModal;
